export enum UnemploymentApplicationStatus {
  TO_BE_TREATED= '*',
  CLOSED = '0',
  COMPLETED = '1',
  IMPOSSIBLE = '2',
  INCOMPLETE = '3',
  SUBMISSION =  '4',
  EXTEND_DEADLINE = '5',
  EXPECTED_EXTENDED_DEADLINE = '6',
}
